// extracted by mini-css-extract-plugin
export var avatarBone = "_g-4";
export var buttonBone = "_g-3";
export var continueBone = "_g-a";
export var frame = "_g-1";
export var logoBone = "_g-2";
export var pickerGrid = "_g-d";
export var pitchBone = "_g-9";
export var productBone = "_g-8";
export var sectionBone = "_g-7";
export var shell = "_g-0";
export var skeletonPulse = "_g-b";
export var subtitleBone = "_g-6";
export var titleBone = "_g-5";
export var viewport = "_g-c";